import { Directive, Input } from '@angular/core';
import { toBoolean } from '../util/util';
import { NglPill } from './pill';
var NglPillRemove = (function () {
    function NglPillRemove(pill) {
        this.pill = pill;
    }
    Object.defineProperty(NglPillRemove.prototype, "nglPillRemovable", {
        set: function (removable) {
            this.pill.removable = toBoolean(removable);
            this.pill.detector.markForCheck();
        },
        enumerable: true,
        configurable: true
    });
    NglPillRemove.prototype.ngOnInit = function () {
        if (this.pill.removable === undefined) {
            this.pill.removable = true;
        }
    };
    NglPillRemove.decorators = [
        { type: Directive, args: [{
                    selector: '[nglPillRemove]',
                },] },
    ];
    /** @nocollapse */
    NglPillRemove.ctorParameters = function () { return [
        { type: NglPill, },
    ]; };
    NglPillRemove.propDecorators = {
        'nglPillRemovable': [{ type: Input },],
    };
    return NglPillRemove;
}());
export { NglPillRemove };
//# sourceMappingURL=pill-remove.js.map